import { useState } from 'react';
import './App.css';
import Page from './common/Page';
import Title from './common/Title';

function App() {
  const [currentPage, setCurrentPage] = useState("start");

  return (
    <>
      <Title />
      <Page currentPage={currentPage} setCurrentPage={setCurrentPage} />
    </>
  );
}

export default App;

// TODO: Proofread
// TODO: Photo